import { setDisplayErrorSnackBar } from "../../features/userSlice";
import { dealsPromotionsEndpoints } from "../../services/api/deals-promotions.endpoints";
import { metaEntitiesService } from "../../services/api/meta-entities.endpoints";
import {
  setDealsPortfolioPlans,
  setIsLoadingDealsPortfolioPlans,
  setCurrencies,
} from "../../features/dealsPromotionsSlice";
import store from "../../store";

async function getDealsPortfolioPlans(oauthTokenHeader: string) {
  store.dispatch(setIsLoadingDealsPortfolioPlans(true));
  try {
    const response =
      await dealsPromotionsEndpoints.getDealsPortfolioPlans(oauthTokenHeader);
    if (!response || !response.status) {
      throw new Error(
        "An error occurred while fetching deals portfolio plans.",
      );
    } else if (response.status === 200) {
      const raw = response?.data?.data ?? [];
      const plans = raw.map((item: any) => ({
        ...item,
        website: item.website_name,
        status: item.is_partial ? "Partial" : "Complete",
        rs: item.rs_percent != null ? `${item.rs_percent}%` : "",
        currency: item.currency__abbreviation,
      }));
      store.dispatch(setDealsPortfolioPlans(plans));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "An error occurred while fetching deals portfolio plans.",
        type: "error",
      }),
    );
  } finally {
    store.dispatch(setIsLoadingDealsPortfolioPlans(false));
  }
}

async function updateDealsPortfolioPlans(
  oauthTokenHeader: string,
  brandId: string,
  body: any,
) {
  try {
    const response = await dealsPromotionsEndpoints.updateDealsPortfolioPlans(
      oauthTokenHeader,
      brandId,
      body,
    );
    if (!response || !response.status) {
      throw new Error(
        "An error occurred while updating deals portfolio plans.",
      );
    }
    return response;
  } catch (e: any) {
    return { error: e?.parsedText || "An error occurred while updating deals portfolio plans." };
  }
}

async function getCurrencies(oauthTokenHeader: string) {
  try {
    const response = await metaEntitiesService.getMetaCurrencies(oauthTokenHeader);
    if (!response || response.status !== 200) {
      throw new Error("Failed to fetch currencies.");
    }
    store.dispatch(setCurrencies(response.data?.data ?? []));
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Failed to fetch currencies.",
        type: "error",
      }),
    );
  }
}

export const dealsPromotionsEndpointLogic = {
  getDealsPortfolioPlans,
  updateDealsPortfolioPlans,
  getCurrencies,
};
